import {
  QUICK_FILTER_SOURCE,
  buildMetricAndFilters,
  metricRuleItem,
} from "../quickFilterUtils";

/**
 * Shared dummy metric presets (placeholder rules).
 * Page configs should pass page/platform-specific measure member ids.
 */
export const createDummyMetricPresets = (pageId, platform, metricKeys = {}) => {
  const {
    spend = "spends",
    roas = "roas",
    orders = "orders",
  } = metricKeys;
  const now = "2026-01-01T00:00:00.000Z";
  const suffix = `${pageId}_${platform}`;

  return [
    {
      id: `system_top_performers_${suffix}`,
      name: "Top performers",
      description: "ROAS > 0 and Spend > 0",
      source: QUICK_FILTER_SOURCE.SYSTEM,
      createdAt: now,
      updatedAt: now,
      filterModuleFilters: buildMetricAndFilters([
        metricRuleItem(roas, "gt", [0]),
        metricRuleItem(spend, "gt", [0]),
      ]),
    },
    {
      id: `system_high_spend_low_roas_${suffix}`,
      name: "High spend, low ROAS",
      description: "Spend > 1000 and ROAS < 1",
      source: QUICK_FILTER_SOURCE.SYSTEM,
      createdAt: now,
      updatedAt: now,
      filterModuleFilters: buildMetricAndFilters([
        metricRuleItem(spend, "gt", [1000]),
        metricRuleItem(roas, "lt", [1]),
      ]),
    },
    {
      id: `system_zero_sales_with_spend_${suffix}`,
      name: "Zero sales with spend",
      description: "Orders/Units = 0 and Spend > 0",
      source: QUICK_FILTER_SOURCE.SYSTEM,
      createdAt: now,
      updatedAt: now,
      filterModuleFilters: buildMetricAndFilters([
        metricRuleItem(orders, "equals", [0]),
        metricRuleItem(spend, "gt", [0]),
      ]),
    },
  ];
};
